import { createSlotRecipe } from './runtime';

const splitViewConfig = {"name":"splitView","slots":["root","pane","splitter","grip"]}

export const splitView = /* @__PURE__ */ createSlotRecipe(splitViewConfig)